const basinRoles = {
  id: "basinRoles",
  label: "Basin Roles",
  endpoint: "roles/basin",
  responseBodyKey: "roles",
  columnConfig: [
    {
      field: "name",
      headerName: "Basin Role",
      width: 250,
      description: "Basin Role",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default basinRoles;
